import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-4 left-4 right-4 md:left-1/2 md:right-auto md:transform md:-translate-x-1/2 z-50 max-w-md w-auto md:w-full"
}
const _hoisted_2 = { class: "bg-white dark:bg-gray-800 rounded-lg shadow-2xl border border-gray-200 dark:border-gray-700 p-4 flex items-center gap-3 md:gap-4" }
const _hoisted_3 = { class: "flex-shrink-0" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex gap-2 flex-shrink-0" }
const _hoisted_6 = { class: "bg-white dark:bg-gray-800 w-full max-w-md rounded-2xl sm:rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 p-5 space-y-4 max-h-[90vh] overflow-y-auto animate-modal" }
const _hoisted_7 = { class: "flex items-center justify-between pb-3 border-b border-gray-100 dark:border-gray-700" }
const _hoisted_8 = { class: "flex items-center gap-3" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_11 = {
  key: 0,
  class: "space-y-3.5 text-sm"
}
const _hoisted_12 = {
  key: 1,
  class: "space-y-3.5 text-sm"
}
const _hoisted_13 = { class: "pt-2 flex flex-col sm:flex-row gap-2" }

import { computed } from 'vue'
import { usePWAInstall } from '@/composables/usePWAInstall'


export default /*@__PURE__*/_defineComponent({
  __name: 'PWAInstallPrompt',
  setup(__props) {

const {
  showInstallPrompt,
  isInstalled,
  isMacSafari,
  showIOSInstructions,
  installPWA,
  closeIOSInstructions,
  dismissInstallPrompt
} = usePWAInstall()

const publicPath = process.env.BASE_URL || '/portal/'
const formattedPublicPath = computed(() => {
  return publicPath.endsWith('/') ? publicPath : `${publicPath}/`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "slide-up" }, {
      default: _withCtx(() => [
        (_unref(showInstallPrompt) && !_unref(isInstalled))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: `${formattedPublicPath.value}icons/web-app-manifest-192x192.png`,
                    alt: "App Icon",
                    class: "w-10 h-10 md:w-12 md:h-12 rounded-lg object-contain"
                  }, null, 8, _hoisted_4)
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-1 min-w-0" }, [
                  _createElementVNode("h3", { class: "text-sm font-semibold text-gray-900 dark:text-white" }, " Install App "),
                  _createElementVNode("p", { class: "text-xs text-gray-600 dark:text-gray-400 mt-0.5 hidden sm:block" }, " Install this app on your device for quick and easy access ")
                ], -1)),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(installPWA) && _unref(installPWA)(...args))),
                    class: "px-3 py-2 md:px-4 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-md transition-colors shadow-sm"
                  }, " Install "),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(dismissInstallPrompt) && _unref(dismissInstallPrompt)(...args))),
                    class: "px-2 py-2 md:px-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 text-sm transition-colors",
                    "aria-label": "Dismiss"
                  }, " ✕ ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_unref(showIOSInstructions))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-end sm:items-center justify-center p-3 sm:p-4",
              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_unref(closeIOSInstructions) && _unref(closeIOSInstructions)(...args)), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: `${formattedPublicPath.value}icons/web-app-manifest-192x192.png`,
                      alt: "Jeducare Logo",
                      class: "w-9 h-9 rounded-lg object-contain bg-gray-50 dark:bg-gray-700 p-0.5"
                    }, null, 8, _hoisted_9),
                    _createElementVNode("div", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-base font-semibold text-gray-900 dark:text-white" }, " Install Jeducare App ", -1)),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(isMacSafari) ? 'Safari for Mac' : 'Safari for iOS / Apple'), 1)
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(closeIOSInstructions) && _unref(closeIOSInstructions)(...args))),
                    class: "text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 p-1 rounded-lg transition-colors",
                    "aria-label": "Close"
                  }, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("svg", {
                      class: "w-5 h-5",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12"
                      })
                    ], -1)
                  ]))])
                ]),
                (!_unref(isMacSafari))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("p", { class: "text-xs text-gray-600 dark:text-gray-300" }, " Apple Safari does not allow automatic installs, but you can add Jeducare to your home screen in 3 quick steps: ", -1),
                      _createElementVNode("div", { class: "flex items-start gap-3 p-3 bg-gray-50 dark:bg-gray-750 rounded-xl border border-gray-100 dark:border-gray-700" }, [
                        _createElementVNode("div", { class: "p-2 bg-indigo-50 dark:bg-indigo-950/60 text-indigo-600 dark:text-indigo-400 rounded-lg flex-shrink-0" }, [
                          _createElementVNode("svg", {
                            class: "w-5 h-5",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" }),
                            _createElementVNode("polyline", { points: "16 6 12 2 8 6" }),
                            _createElementVNode("line", {
                              x1: "12",
                              y1: "2",
                              x2: "12",
                              y2: "15"
                            })
                          ])
                        ]),
                        _createElementVNode("div", { class: "min-w-0" }, [
                          _createElementVNode("span", { class: "font-semibold text-gray-900 dark:text-white" }, "Step 1:"),
                          _createElementVNode("p", { class: "text-xs text-gray-600 dark:text-gray-300 mt-0.5" }, [
                            _createTextVNode(" Tap the "),
                            _createElementVNode("strong", null, "Share"),
                            _createTextVNode(" button in Safari's toolbar (at the bottom on iPhone, or top on iPad). ")
                          ])
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "flex items-start gap-3 p-3 bg-gray-50 dark:bg-gray-750 rounded-xl border border-gray-100 dark:border-gray-700" }, [
                        _createElementVNode("div", { class: "p-2 bg-indigo-50 dark:bg-indigo-950/60 text-indigo-600 dark:text-indigo-400 rounded-lg flex-shrink-0" }, [
                          _createElementVNode("svg", {
                            class: "w-5 h-5",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("rect", {
                              x: "3",
                              y: "3",
                              width: "18",
                              height: "18",
                              rx: "4",
                              ry: "4"
                            }),
                            _createElementVNode("line", {
                              x1: "12",
                              y1: "8",
                              x2: "12",
                              y2: "16"
                            }),
                            _createElementVNode("line", {
                              x1: "8",
                              y1: "12",
                              x2: "16",
                              y2: "12"
                            })
                          ])
                        ]),
                        _createElementVNode("div", { class: "min-w-0" }, [
                          _createElementVNode("span", { class: "font-semibold text-gray-900 dark:text-white" }, "Step 2:"),
                          _createElementVNode("p", { class: "text-xs text-gray-600 dark:text-gray-300 mt-0.5" }, [
                            _createTextVNode(" Scroll down the share sheet and tap "),
                            _createElementVNode("strong", null, "\"Add to Home Screen\""),
                            _createTextVNode(". ")
                          ])
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "flex items-start gap-3 p-3 bg-gray-50 dark:bg-gray-750 rounded-xl border border-gray-100 dark:border-gray-700" }, [
                        _createElementVNode("div", { class: "p-2 bg-indigo-50 dark:bg-indigo-950/60 text-indigo-600 dark:text-indigo-400 rounded-lg flex-shrink-0" }, [
                          _createElementVNode("svg", {
                            class: "w-5 h-5",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                          ])
                        ]),
                        _createElementVNode("div", { class: "min-w-0" }, [
                          _createElementVNode("span", { class: "font-semibold text-gray-900 dark:text-white" }, "Step 3:"),
                          _createElementVNode("p", { class: "text-xs text-gray-600 dark:text-gray-300 mt-0.5" }, [
                            _createTextVNode(" Tap "),
                            _createElementVNode("strong", null, "\"Add\""),
                            _createTextVNode(" in the top-right corner to complete installation. ")
                          ])
                        ])
                      ], -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("p", { class: "text-xs text-gray-600 dark:text-gray-300" }, " To install Jeducare on macOS using Safari: ", -1),
                      _createElementVNode("div", { class: "flex items-start gap-3 p-3 bg-gray-50 dark:bg-gray-750 rounded-xl border border-gray-100 dark:border-gray-700" }, [
                        _createElementVNode("div", { class: "p-2 bg-indigo-50 dark:bg-indigo-950/60 text-indigo-600 dark:text-indigo-400 rounded-lg flex-shrink-0" }, [
                          _createElementVNode("svg", {
                            class: "w-5 h-5",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
                            _createElementVNode("polyline", { points: "14 2 14 8 20 8" })
                          ])
                        ]),
                        _createElementVNode("div", { class: "min-w-0" }, [
                          _createElementVNode("span", { class: "font-semibold text-gray-900 dark:text-white" }, "Step 1:"),
                          _createElementVNode("p", { class: "text-xs text-gray-600 dark:text-gray-300 mt-0.5" }, [
                            _createTextVNode(" Click "),
                            _createElementVNode("strong", null, "File"),
                            _createTextVNode(" in Safari's top menu bar. ")
                          ])
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "flex items-start gap-3 p-3 bg-gray-50 dark:bg-gray-750 rounded-xl border border-gray-100 dark:border-gray-700" }, [
                        _createElementVNode("div", { class: "p-2 bg-indigo-50 dark:bg-indigo-950/60 text-indigo-600 dark:text-indigo-400 rounded-lg flex-shrink-0" }, [
                          _createElementVNode("svg", {
                            class: "w-5 h-5",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("rect", {
                              x: "2",
                              y: "3",
                              width: "20",
                              height: "14",
                              rx: "2",
                              ry: "2"
                            }),
                            _createElementVNode("line", {
                              x1: "8",
                              y1: "21",
                              x2: "16",
                              y2: "21"
                            }),
                            _createElementVNode("line", {
                              x1: "12",
                              y1: "17",
                              x2: "12",
                              y2: "21"
                            })
                          ])
                        ]),
                        _createElementVNode("div", { class: "min-w-0" }, [
                          _createElementVNode("span", { class: "font-semibold text-gray-900 dark:text-white" }, "Step 2:"),
                          _createElementVNode("p", { class: "text-xs text-gray-600 dark:text-gray-300 mt-0.5" }, [
                            _createTextVNode(" Select "),
                            _createElementVNode("strong", null, "\"Add to Dock...\""),
                            _createTextVNode(" and click "),
                            _createElementVNode("strong", null, "Add"),
                            _createTextVNode(". ")
                          ])
                        ])
                      ], -1)
                    ]))])),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(closeIOSInstructions) && _unref(closeIOSInstructions)(...args))),
                    class: "w-full py-2.5 px-4 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-lg transition-colors shadow-sm"
                  }, " Got it "),
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(dismissInstallPrompt) && _unref(dismissInstallPrompt)(...args))),
                    class: "w-full sm:w-auto py-2.5 px-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 text-xs transition-colors"
                  }, " Don't show again ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})